import React, { ReactFragment, SetStateAction } from "react"
import { Outlet } from "react-router-dom"
import { StyledBreakpointsTheme } from 'styled-breakpoints';
import { breakPointsTheme } from './theme';

export type ThemeType = "dark" | "light"

type ThemeContextType = {
    theme: ThemeType,
    setTheme?: React.Dispatch<SetStateAction<ThemeType>>,
    breakPointsTheme: StyledBreakpointsTheme<"xs" | "sm" | "md" | "lg" | "xl" | "xxl", "sm" | "md" | "lg" | "xl" | "xxl">
}

let pageMode: ThemeType = typeof localStorage.getItem("theme") === "string" ? localStorage.getItem("theme") as "dark" | "light" : "dark"
let context: ThemeContextType = { theme: pageMode, breakPointsTheme}

if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    pageMode = "dark";
    localStorage.theme = 'dark'
    document.documentElement.classList.add('dark')
} else {
    pageMode = "light"
    localStorage.theme = "light"
    document.documentElement.classList.remove('dark')
}

export const ThemeContext = React.createContext(context)

export const ThemeProvider: React.FC = () => {
    const [theme, setTheme] = React.useState(pageMode)

    return <ThemeContext.Provider value={{ theme, setTheme, breakPointsTheme }}>
        {/* Theme Configuration */}
        <Outlet />
    </ThemeContext.Provider>
}